import $ from 'jquery';
import { defaultsDeep } from 'lodash';
import Radio from 'backbone.radio';
import videojs from 'video.js';
import 'videojs-markers';
import qs from '@silvermine/videojs-quality-selector';

const DEFAULTS = {
  fluid: true,
  aspectRatio: '16:9',
  controlBar: {
    children: [
      "playToggle",
      "volumePanel",
      "currentTimeDisplay",
      "durationDisplay",
      "progressControl",
      "playbackRateMenuButton",
      "subsCapsButton",
      "fullscreenToggle",
    ],
    volumePanel: { inline: false }
  },
  playbackRates: [0.5, 1, 1.5, 2],
  html5: {
    vhs: {
      // XXX: Looks like experimental ABR better meets my expectations.
      experimentalBufferBasedABR: true,
      // XXX: Force start playing with high quality by disabling limitRenditionByPlayerDimensions and setting high initial bandwidth.
      bandwidth: 100000000,
      limitRenditionByPlayerDimensions: false
    }
  }
};
const DATA_PROPERTY = 'videoPlayer'; // data property to store player object

const globalChannel = Radio.channel('global');

qs(videojs); // QualitySelector

export function initVideoPlayer(element, options) {
  options = defaultsDeep(options || {}, DEFAULTS);

  const $videoEl = $(element);
  if ($videoEl.data(DATA_PROPERTY)) return; // Already initialized

  // Checking if there is no HLS type video in video player source
  if ($videoEl.find("[type='application/x-mpegURL']").length === 0) {
    options.controlBar.children.push('QualitySelector')
  }

  // VideoJS Player initialization
  const videoId = $videoEl.prop('id');
  const player = videojs(videoId, options);
  const eventLabel = player.tagAttributes['data-event-label'];
  const sendImpression = player.tagAttributes['data-send-impression'];
  let videoPlayedFlag = false;
  let videoFinishedFlag = false;
  let playerinitdone = false;

  player.on('play', () => {
    if (!videoPlayedFlag) {
      trackEvent('Play', eventLabel);
      videoPlayedFlag = true;
    }
  });
  player.on('ended', () => {
    if (!videoFinishedFlag) {
      trackEvent('Completed', eventLabel);
      videoFinishedFlag = true;
    }
  });

  player.markers({ // Initializing Chapter Markers Plugin
    markerTip: {
      display: true,
      text: (marker) => marker.text
    },
  });

  const seekCallback = seek => {
    player.currentTime(seek)
  }
  const radioEvent = `video_player:${videoId}:seek`

  // Navigation from markers
  globalChannel.on(radioEvent, seekCallback);

  player.on('dispose', () => {
    globalChannel.off(radioEvent, seekCallback)
  })

  player.on('canplaythrough', () => { // we use 'canplaythrough' instead of 'loadmetadata' because of iOs bugs
    if(!playerinitdone) {
      // Making list of Chapter Markers
      const markers = []

      player.textTracks().tracks_.forEach(track => {
        if (track.kind == 'chapters') {
          const chapters = track.cues_;
          if (chapters) {
            chapters.forEach(chapter => {
              markers.push({
                time: chapter.startTime,
                text: chapter.text
              })
            })
          }
        }
      })
      player.markers.add(markers);
      playerinitdone = true;
    }
  });

  setup50PercentViewedTracker(player, eventLabel);

  // Send impression event at the next cycle because GA and snowplow can be not initialized yet.
  if (sendImpression) setTimeout(() => { trackEvent('Impression', eventLabel) }, 0);

  const back10button = player.controlBar.addChild('button');
  const back10buttonDOM = back10button.el();

  back10button.addClass('vj-back10');
  $(back10buttonDOM).html("&#8617; <span>10s</span>");

  $(`#${videoId}-player`).on('touchstart click', '.vj-back10', () => {
    player.currentTime(player.currentTime() - 10);
  });


  $videoEl.data(DATA_PROPERTY, player); // associate player object with video element

  return player;
}

export function destroyVideoPlayer(videoElement) {
  const player = $(videoElement).data(DATA_PROPERTY);
  if (player) {
    player.dispose()
    $(videoElement).data(DATA_PROPERTY, null)
  }
}

export function videoJsPlayer() {
  const videos = $('video');

  videos.each((_index, video) => {
    initVideoPlayer(video);
  })
}

// Setup custom GA event tracking when 50% of video watched
function setup50PercentViewedTracker(player, eventLabel) {
  let durationWatcherInterval,
      notifiedGA = false;

  const percentWatcher = function() {
    if (notifiedGA) return;

    const duration = player.duration();
    if (!duration) return;

    const viewedPercentage = Math.round(
      player.currentTime() / duration * 100
    );

    if (viewedPercentage >= 50) {
      notifiedGA = true;
      trackEvent('Watched-50', eventLabel);
      stopWatch();
    }
  };

  const stopWatch = function() {
    if (durationWatcherInterval) {
      clearInterval(durationWatcherInterval);
      durationWatcherInterval = null;
    }
  };

  const startWatch = function() {
    if (notifiedGA || durationWatcherInterval) return;
    durationWatcherInterval = setInterval(percentWatcher, 1000);
  }

  player.on('play', startWatch);
  player.on('dispose', stopWatch);
  player.on('pause', stopWatch);
  player.on('seek', stopWatch);
}

function trackEvent(event, eventLabel) {
  if (!eventLabel) return;
  ga('send', 'event', 'VJS Player Video', event, eventLabel);

  snowplow('trackStructEvent', {
    category: 'VJS Player Video',
    action: event,
    label: eventLabel
  });
}
